var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"name":"test"}},[_c('f7-block',[_c('f7-button',{on:{"click":function($event){return _vm.add()}}},[_vm._v("Add")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }